import React from "react";

export const Texterror = ({ children }) => {
  return <div><span style={{ color: 'rgb(255, 103, 103)', fontSize: "12px" }}>{children}</span></div>;
};